import { CUSTOMER_ADMIN_CLIENT_ID } from '~common/constants';

interface IClientConfig {
  idpServerUrl: string;
  hostBaseUrl: string;
  jiraBaseUrl: string;
  clientId: string;
  enableSentry: boolean;
  sentryEnvironment: string;
  pkce: {
    provider: 'oidc-client-ts' | 'axa-fr';
    renewTokenMode: 'refresh-token' | 'silent-renew';
  };
}

export const HOST_BASE_URL = `${window.location.protocol}//${
  window.location.hostname
}${window.location.port ? `:${window.location.port}` : ''}`;

export default class ClientConfig {
  static get config(): IClientConfig {
    const runtimeConfig = window.__runtimeConfigStatic;
    const idpBaseUrl = runtimeConfig?.authentication_server_base_url;
    const clientId = runtimeConfig?.user_client_id || CUSTOMER_ADMIN_CLIENT_ID;
    const provider = runtimeConfig?.pkce?.provider;
    const jiraBaseUrl = runtimeConfig?.jira_base_url;
    const enableSentry = runtimeConfig?.enable_sentry;
    const sentryEnvironment = runtimeConfig?.sentry_environment;

    const renewTokenMode = runtimeConfig?.pkce?.renew_token_mode;

    return {
      clientId,
      idpServerUrl: idpBaseUrl,
      hostBaseUrl: HOST_BASE_URL,
      jiraBaseUrl,
      enableSentry,
      sentryEnvironment,
      pkce: {
        provider,
        renewTokenMode,
      },
    };
  }
}
